/*
  Twirling Boutique, refonte des fiches produit de juillet 2026.

  Deux comportements que les maquettes demandent et que le theme ne fournit pas :
  le compteur de caracteres du module de gravure, et la barre d'ajout collante en
  mobile.

  Regle tenue ici : rien de ce fichier n'est indispensable a l'achat. Si le script
  ne se charge pas, la saisie de gravure fonctionne toujours (maxlength est porte
  par l'attribut HTML) et le bouton d'ajout de la page reste utilisable. La barre
  collante est un raccourci, jamais le seul chemin.
*/
(function () {
  'use strict';

  function compteurGravure(racine) {
    var champs = racine.querySelectorAll('.tw-eng__input[data-tw-counter-for]');
    Array.prototype.forEach.call(champs, function (champ) {
      if (champ.closest('.tw-eng--housse')) return;
      var sortie = document.getElementById(champ.getAttribute('data-tw-counter-for'));
      if (!sortie) return;
      var max = champ.getAttribute('maxlength') || '';
      var nb = parseInt(max, 10);
      var poser = function () {
        sortie.textContent = champ.value.length + ' / ' + max;
        /*
          La limite EXISTE (maxlength la tient), mais rien ne la disait : le champ
          cessait simplement d'accepter les lettres, ce qui se lit comme une panne.
          Le compteur s'allume quand elle mord. La cliente a fait retirer la mention
          permanente « 15 caracteres maximum » : on ne la remet pas, on la montre au
          seul moment ou elle sert.
        */
        if (nb > 0 && champ.value.length >= nb) {
          sortie.classList.add('tw-eng__count--plein');
        } else {
          sortie.classList.remove('tw-eng__count--plein');
        }
      };
      champ.addEventListener('input', poser);
      poser();
    });
  }

  /*
    Le tarif inscrit sur un bouton de taille est rendu par le serveur : c'est celui de
    la PREMIERE variante disponible qui porte cette taille, donc toujours celui de la
    piece sur un produit a lots. Chaque bouton affichait 10,00 € pendant que le pack a
    25,00 € etait choisi.

    Le bouton emporte sa propre carte des tarifs, une entree par offre. On y pose celui
    de l'offre en cours. Sans carte, on ne touche a rien : les produits sans lot gardent
    leur tarif serveur.
  */
  function tarifsParOffre(racine) {
    var section = racine.querySelector('.tw-refonte');
    if (!section) return;
    var offres = section.querySelector('.option-selector__btns--tw-offres');
    if (!offres) return;
    var cibles = section.querySelectorAll('[data-tw-prix-map]');
    if (!cibles.length) return;

    var poser = function () {
      var coche = offres.querySelector('.opt-btn:checked');
      if (!coche) return;
      var offre = coche.value;
      for (var i = 0; i < cibles.length; i++) {
        var champ = cibles[i].querySelector('.opt-label__price');
        if (!champ) continue;
        var paires = (cibles[i].getAttribute('data-tw-prix-map') || '').split('|');
        for (var j = 0; j < paires.length; j++) {
          var k = paires[j].indexOf('=');
          if (k < 0) continue;
          if (paires[j].slice(0, k) === offre) {
            champ.textContent = paires[j].slice(k + 1);
            break;
          }
        }
      }
    };

    section.addEventListener('change', poser);
    poser();
  }

  /*
    La barre collante ne duplique PAS le bouton d'achat : elle soumet le vrai
    formulaire produit. Un second bouton d'ajout ecrirait une seconde fois la
    logique de panier du theme, et les deux divergeraient au premier changement.

    Son libelle est recopie depuis le prix affiche et l'option choisie, puis
    resuivi : le theme reecrit ces elements a chaque changement de variante, sans
    emettre d'evenement sur lequel s'accrocher.
  */
  function barreCollante(racine) {
    var section = racine.querySelector('.tw-refonte');
    if (!section) return;
    var form = section.querySelector('form.product-purchase-form');
    var bouton = section.querySelector('#addToCartButton');
    if (!form || !bouton) return;
    if (document.querySelector('.tw-sticky-add')) return;

    /*
      Le prix se RE-INTERROGE a chaque calcul, il ne se garde pas en reference.
      Au changement de variante le theme REMPLACE le bloc de prix : l'element
      qu'on tenait sort du document et reste fige sur le montant du depart. La
      barre annoncait « Ajouter · €10,00 · Pack de 3 » sur un pack a 25,00 €,
      c'est-a-dire un prix faux sur le bouton qui declenche l'achat.
      Meme piege, meme parade que dans totalSurLeBouton().
    */
    var lirePrixEl = function () {
      return section.querySelector('.price-container .theme-money')
          || section.querySelector('.price .theme-money')
          || section.querySelector('.price');
    };
    // L'observateur se pose sur le CONTENEUR, qui survit au remplacement.
    var ancrePrix = section.querySelector('.price-container') || section;
    var barre = document.createElement('div');
    barre.className = 'tw-sticky-add';
    barre.innerHTML =
      '<button type="button" class="tw-sticky-add__btn"></button>';
    var btn = barre.querySelector('.tw-sticky-add__btn');

    var lireOption = function () {
      var coche = section.querySelector('.option-selector__btns .opt-btn:checked');
      return coche ? coche.value : '';
    };

    var poser = function () {
      /*
        Le bouton porte parfois DEJA la quantite et le total (fiches ou la maquette
        le demande). Dans ce cas la barre le recopie tel quel : y rajouter le prix
        et la variante ecrivait « ... 165,00 € · l'unite · 16,50 € · l'unite · 4'' ».

        La maquette mobile ecrit « Ajouter », pas « Ajouter au panier » : la barre
        est etroite, et le prix compte plus que le verbe long.
      */
      var texte = (bouton.textContent || '').trim();
      var aDejaLeTotal = /[0-9]/.test(texte) && /[€$£]|EUR/.test(texte);
      var verbe = texte.replace(/\s+au panier/i, '');
      if (aDejaLeTotal) {
        btn.textContent = verbe;
        btn.disabled = bouton.disabled;
        return;
      }
      var morceaux = [verbe || 'Ajouter'];
      // On lit le MONTANT seul : le suffixe d'unite vit dans le meme bloc que lui.
      var el = lirePrixEl();
      var montant = el ? (el.querySelector ? (el.querySelector('.theme-money') || el) : el) : null;
      if (montant && montant.textContent.trim()) morceaux.push(montant.textContent.trim());
      var opt = lireOption();
      if (opt) morceaux.push(opt);
      btn.textContent = morceaux.join(' · ');
      btn.disabled = bouton.disabled;
    };

    btn.addEventListener('click', function () {
      // On clique le vrai bouton : le theme y a accroche sa logique de panier.
      bouton.click();
    });

    section.addEventListener('change', poser);
    if (window.MutationObserver) {
      new MutationObserver(poser).observe(ancrePrix, {
        childList: true, characterData: true, subtree: true
      });
    }

    document.body.appendChild(barre);
    document.documentElement.classList.add('tw-refonte-has-sticky');
    poser();

    /*
      La barre ne double pas le bouton de la page : elle apparait quand il sort
      de l'ecran et s'efface des qu'il revient. Sans ca elle restait affichee en
      permanence, y compris juste sous le vrai bouton.

      L'observateur porte sur le bouton lui-meme. Il n'est jamais retire du
      document par le theme, contrairement au bloc de prix : le garder en
      reference est sans risque ici.
    */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entrees) {
        for (var i = 0; i < entrees.length; i++) {
          barre.classList.toggle('tw-sticky-add--on', !entrees[i].isIntersecting);
        }
      }).observe(bouton);
    } else {
      // Sans observateur, mieux vaut une barre toujours la qu'aucun bouton.
      barre.classList.add('tw-sticky-add--on');
    }
  }

  /*
    Les cartes du bas (accordeon, avis, cross-sell) sont des SECTIONS SOEURS de la
    fiche produit : aucune regle CSS partant de .tw-refonte ne peut les atteindre.
    On marque donc la page elle-meme quand une fiche refondue est affichee.
  */
  function marquerLaPage(racine) {
    if (racine.querySelector('.tw-refonte')) {
      document.documentElement.classList.add('tw-refonte-page');
    }
  }

  /*
    Recapitulatif du configurateur. Il est ECRIT par le script, jamais rendu par
    Liquid : Liquid ne voit pas ce que le client vient de cocher.

    Son absence ne bloque rien : les choix restent selectionnables et partent en
    proprietes de ligne, seule la phrase manque.
  */
  function recapConfigurateur(racine) {
    var blocs = racine.querySelectorAll('[data-tw-composer]');
    Array.prototype.forEach.call(blocs, function (bloc) {
      var sortie = bloc.querySelector('[data-tw-composer-values]');
      if (!sortie) return;
      var poser = function () {
        var choix = [];
        Array.prototype.forEach.call(bloc.querySelectorAll('.tw-cmp__radio:checked'), function (r) {
          if (!r.value) return;
          // Une couleur ne se lit pas seule : « rouge » ne dit pas rouge de quoi.
          // Une combinaison, si : son libelle d'etape n'apporte rien.
          if (r.getAttribute('data-tw-type') === 'colors') {
            var etape = r.getAttribute('data-tw-step') || '';
            choix.push((etape + ' ' + r.value).trim().toLowerCase());
          } else {
            choix.push(r.value.toLowerCase());
          }
        });
        sortie.textContent = choix.length ? ' ' + choix.join(' + ') + '.' : '';
      };
      bloc.addEventListener('change', poser);
      poser();
    });
  }

  /*
    LE SUPPLEMENT DE 8 EUROS EST PORTE PAR L'APPLICATION, PAS PAR NOUS.

    Sur le site actuel, cocher « Gravure » fait passer le baton de 37 a 45 €. La case
    qui le fait s'appelle « properties[Gravure] » et porte la classe « pplraddprice ».
    La refonte MASQUE le widget de l'application pour ne montrer que le module de la
    maquette : la case existe toujours dans le formulaire, mais plus personne ne la
    coche, et la gravure partait donc a zero euro.

    Notre champ pilote donc la case sans la montrer. On la « clique » plutot que de
    forcer .checked : l'application ecoute le clic, et une propriete posee a la main
    ne declencherait aucun recalcul de prix.

    Notre propre propriete est retiree du formulaire quand l'application prend le
    relais : deux lignes disant la meme chose dans le panier, dont une seule facturee,
    se lit comme une erreur.
  */
  function gravureVersApp(racine) {
    var section = racine.querySelector('.tw-refonte');
    if (!section) return;
    var mod = section.querySelector('.tw-eng:not(.tw-eng--housse)');
    var mien = mod && mod.querySelector('.tw-eng__input');
    if (!mien) return;

    /*
      LA CASE DE L'APPLICATION N'EXISTE PAS ENCORE QUAND CE CODE TOURNE.

      Mesure du 01/09/2026 sur ba-stpro9 : DOMContentLoaded a 121 ms, la case
      « pplraddprice » injectee a 823 ms. La version precedente la cherchait UNE
      fois, ne la trouvait pas, et sortait sans jamais revenir : la gravure partait
      donc a zero euro, sur tous les produits, tout le temps. Rien dans la console,
      rien de visible a l'ecran, et le defaut disparaissait des qu'on rechargeait
      assez lentement pour que l'application arrive la premiere.

      On l'attend donc, et on ne la garde jamais en reference : l'application
      reconstruit son bloc au changement de variante.
    */
    var caseApp = function () {
      return document.querySelector('input.pplraddprice[name^="properties["]');
    };

    var champApp = function () {
      return document.querySelector('.product-personalizer input.pplr_text[name^="properties["]')
          || document.querySelector('input.pplr_text[name^="properties["]');
    };

    var poser = function () {
      var c = caseApp();
      if (!c) return;
      var t = mien.value.trim();
      var veut = t.length > 0;
      if (c.checked !== veut) c.click();
      // Le champ de l'application n'existe qu'une fois la case cochee : on le
      // rappelle a chaque passage plutot que de le garder en reference.
      var z = champApp();
      if (z && z.value !== t) {
        z.value = t;
        z.dispatchEvent(new Event('input', { bubbles: true }));
        z.dispatchEvent(new Event('change', { bubbles: true }));
        z.dispatchEvent(new Event('keyup', { bubbles: true }));
      }
    };

    var arme = false;
    var armer = function () {
      if (arme || !caseApp()) return arme;
      arme = true;
      // Notre propre propriete est retiree du formulaire SEULEMENT ici : si
      // l'application n'est pas armee sur ce produit, elle reste, et le texte
      // grave part quand meme en propriete de ligne plutot que d'etre perdu.
      mien.removeAttribute('name');
      mien.addEventListener('input', poser);
      mien.addEventListener('change', poser);
      var valider = mod.querySelector('[data-tw-eng-close]');
      if (valider) valider.addEventListener('click', function () { setTimeout(poser, 60); });
      poser();
      return true;
    };

    if (armer()) return;

    var obs = new MutationObserver(function () {
      if (armer()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    // L'application n'est pas installee sur tous les produits : on cesse
    // d'observer plutot que de surveiller la page jusqu'a la fin de la visite.
    setTimeout(function () { if (!arme) obs.disconnect(); }, 20000);
  }

  /*
    « Valider ma gravure » REPLIE le module. Il ne valide rien cote panier : les
    choix sont deja attaches au formulaire en proprietes de ligne, et c'est
    l'ajout au panier qui engage la commande.
  */
  function fermerGravure(racine) {
    Array.prototype.forEach.call(racine.querySelectorAll('[data-tw-eng-close]'), function (b) {
      if (b.closest('.tw-eng--housse')) return;
      var pli = b.closest('details');
      if (!pli) return;
      var titre = pli.querySelector('[data-tw-eng-titre]');
      var champ = pli.querySelector('.tw-eng__input');
      if (!titre) return;
      // Deux libelles : le repli par defaut porte le prix, le repli REMPLI porte le
      // texte grave. « Graver mon baton : +8,00 € : Emma » a deux fois deux points
      // et ne se lit pas : le prix cede sa place au prenom.
      var base = titre.getAttribute('data-tw-eng-titre') || titre.textContent.trim();
      var nom = titre.getAttribute('data-tw-eng-nom') || base;

      /*
        « Le truc se ferme et c'est tout » : rien ne disait que la gravure etait
        prise. Le titre replie porte donc le texte grave, « Graver mon baton :
        Emma ». Il se remet a son libelle des que le champ est vide : un titre
        qui annoncerait un prenom efface mentirait sur ce qui part en commande.
      */
      var poser = function () {
        var t = champ ? champ.value.trim() : '';
        if (t) {
          titre.textContent = nom + ' : ' + t;
          pli.classList.add('tw-eng--rempli');
        } else {
          titre.textContent = base;
          pli.classList.remove('tw-eng--rempli');
        }
      };

      if (champ) champ.addEventListener('input', poser);
      b.addEventListener('click', function () {
        poser();
        pli.open = false;
        pli.scrollIntoView({ block: 'nearest' });
      });
      poser();
    });
  }

  /*
    Le nuancier : le theme ecrit « Couleur » et s'arrete la. La maquette ecrit
    « Coloris - <le coloris choisi> », parce que les pastilles renvoient vers des
    PRODUITS freres et qu'on doit voir lequel on regarde.

    Le nom du coloris courant se lit sur la pastille active, pas sur le produit :
    c'est elle qui porte le libelle que le client a saisi.
  */
  function nuancier(racine) {
    var holders = racine.querySelectorAll('.tw-refonte .swatch-holder');
    Array.prototype.forEach.call(holders, function (h) {
      var lab = h.querySelector('.label');
      if (!lab || lab.getAttribute('data-tw-done')) return;
      var actif = h.querySelector('.color-swatch.active, .color-swatch[aria-current], .color-list--current .color-swatch');
      if (!actif) {
        var ici = location.pathname.split('/').pop();
        actif = h.querySelector('.color-swatch[data-handle="' + ici + '"]');
      }
      var nom = actif ? (actif.getAttribute('title') || actif.getAttribute('aria-label') || actif.textContent || '').trim() : '';
      lab.textContent = lab.getAttribute('data-tw-label') || (document.documentElement.lang === 'it' ? 'Colore' : 'Coloris');
      if (nom) {
        var span = document.createElement('span');
        span.className = 'tw-swatch-current';
        span.textContent = ' \u00b7 ' + nom;
        lab.appendChild(span);
      }
      lab.setAttribute('data-tw-done', '1');
    });
  }

  /*
    Le bouton d'ajout porte la quantite et le total, comme les maquettes 16 et 21 :
    « Ajouter au panier - 10 pompons . 165,00 € ».

    Le prix unitaire est LU sur le prix affiche, pas recalcule : c'est le theme qui
    le formate, monnaie et separateurs compris, et le refaire ici le ferait diverger
    au premier changement de marche. On ne reformate donc que le nombre, en gardant
    la ponctuation du prix d'origine.

    Si le prix ne se lit pas, le bouton garde son libelle : mieux vaut « Ajouter au
    panier » qu'un total faux.
  */
  function totalSurLeBouton(racine) {
    var wrap = racine.querySelector('.tw-refonte .quantity-wrapper[data-tw-cta-total="true"]');
    if (!wrap) return;
    var section = racine.querySelector('.tw-refonte');
    var bouton = section && section.querySelector('#addToCartButton');
    var champ = wrap.querySelector('input[name="quantity"], input[type="number"], input');
    // Le prix est RE-INTERROGE a chaque calcul, jamais garde en reference : au
    // changement de variante le theme REMPLACE le bloc de prix, et l'element
    // qu'on tenait se retrouve detache du document, fige sur l'ancien montant.
    var lirePrixEl = function () {
      if (!section) return null;
      /*
        querySelector avec une liste de selecteurs rend le premier element dans
        l'ORDRE DU DOCUMENT, pas dans l'ordre de la liste. « .price » est le parent
        de « .theme-money » : il sortait donc en premier, suffixe d'unite compris,
        et le bouton affichait « 165,00 €· l'unite ». On interroge le montant seul
        d'abord, et le conteneur seulement s'il n'existe pas.
      */
      return section.querySelector('.price-container .theme-money')
          || section.querySelector('.price .theme-money')
          || section.querySelector('.price');
    };
    var ancre = section && section.querySelector('.price-container');
    if (!bouton || !champ || !lirePrixEl()) return;

    // Le libelle de reference vient de l'attribut que le theme pose lui-meme :
    // il reecrit le bouton a l'initialisation de la variante, APRES nous, et
    // relire textContent a ce moment-la reprendrait notre propre total.
    var base = (bouton.getAttribute('data-add-to-cart-text') || bouton.textContent || '').trim();
    var unite = wrap.getAttribute('data-tw-cta-unit') || '';
    // Le contenu du lot n'est PAS la quantite au panier : « Par 50 » s'achete en
    // un exemplaire, et le bouton doit annoncer cinquante lightsticks, pas un.
    var lot = parseInt(wrap.getAttribute('data-tw-cta-pack'), 10);
    if (!isFinite(lot) || lot < 1) lot = 1;
    var parDefaut = parseInt(wrap.getAttribute('data-tw-qty-default'), 10);
    if (parDefaut > 1 && parseInt(champ.value, 10) === 1) {
      champ.value = parDefaut;
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var lire = function () {
      var el = lirePrixEl();
      if (!el) return null;
      var t = (el.textContent || '').trim();
      var m = t.match(/([0-9][0-9\s.,\u00a0]*)/);
      if (!m) return null;
      var brut = m[1].replace(/[\s\u00a0]/g, '');
      var virgule = brut.lastIndexOf(','), point = brut.lastIndexOf('.');
      var sep = Math.max(virgule, point);
      var n;
      if (sep > -1 && brut.length - sep <= 3) {
        n = parseFloat(brut.slice(0, sep).replace(/[.,]/g, '') + '.' + brut.slice(sep + 1));
      } else {
        n = parseFloat(brut.replace(/[.,]/g, ''));
      }
      return isFinite(n) ? { valeur: n, gabarit: t } : null;
    };

    var poser = function () {
      var p = lire();
      var q = parseInt(champ.value, 10) || 1;
      if (!p) { bouton.textContent = base; return; }
      var total = (p.valeur * q).toFixed(2);
      // On remet le total dans le gabarit du prix affiche : meme symbole, meme place.
      var affiche = p.gabarit.replace(/([0-9][0-9\s.,\u00a0]*)/,
        total.replace('.', (p.gabarit.indexOf(',') > -1 ? ',' : '.')));
      var morceaux = [base];
      var combien = q * lot;
      // « 1 lightsticks » se lit faux. Le mot s'ecrit « singulier|pluriel », et
      // sans barre le mot unique sert aux deux : rien ne se casse a l'ancienne.
      var mots = unite.split('|');
      var mot = combien > 1 ? (mots[1] || mots[0]) : mots[0];
      if (combien > 1 || mot) morceaux.push(combien + (mot ? ' ' + mot : ''));
      morceaux.push(affiche);
      bouton.textContent = morceaux.length > 1
        ? morceaux[0] + ' \u00b7 ' + morceaux.slice(1).join(' \u00b7 ')
        : morceaux[0];
    };

    champ.addEventListener('input', poser);
    champ.addEventListener('change', poser);
    wrap.addEventListener('click', function () { setTimeout(poser, 30); });

    if (window.MutationObserver) {
      // On observe le CONTENEUR de prix, qui lui reste en place, et non le
      // montant, qui est remplace a chaque variante.
      if (ancre) {
        new MutationObserver(poser).observe(ancre, { childList: true, characterData: true, subtree: true });
      }

      // Le theme reecrit le bouton quand il fixe la variante. On repose notre
      // libelle, en se gardant de boucler sur notre propre ecriture.
      var aNous = '';
      var obsBouton = new MutationObserver(function () {
        if (bouton.textContent.trim() === aNous) return;
        obsBouton.disconnect();
        poser();
        aNous = bouton.textContent.trim();
        obsBouton.observe(bouton, { childList: true, characterData: true, subtree: true });
      });
      obsBouton.observe(bouton, { childList: true, characterData: true, subtree: true });
      poser();
      aNous = bouton.textContent.trim();
    } else {
      poser();
    }
  }

  /*
    Repartition par couleur : le total se controle a l'ecran.

    C'est un CONFORT, pas une barriere. Sans ce script les champs restent
    saisissables et partent avec la commande : on ne bloque pas un achat sur un
    calcul qui peut ne pas s'executer. Le message dit ce qui manque, il
    n'empeche rien.
  */
  function repartition(racine) {
    var blocs = racine.querySelectorAll('[data-tw-mix]');
    Array.prototype.forEach.call(blocs, function (bloc) {
      var etat = bloc.querySelector('[data-tw-mix-etat]');
      var champs = bloc.querySelectorAll('[data-tw-mix-champ]');
      if (!etat || !champs.length) return;
      var cible = parseInt(bloc.getAttribute('data-tw-mix-target'), 10) || 0;
      var poser = function () {
        var somme = 0;
        Array.prototype.forEach.call(champs, function (c) {
          var v = parseInt(c.value, 10);
          somme += isFinite(v) && v > 0 ? v : 0;
        });
        var reste = cible - somme;
        etat.classList.remove('tw-mix__etat--ok', 'tw-mix__etat--reste', 'tw-mix__etat--trop');
        var mot;
        if (reste === 0) {
          mot = (bloc.getAttribute('data-tw-ok') || '\u2713 [n]/[m] repartis');
          etat.classList.add('tw-mix__etat--ok');
        } else if (reste > 0) {
          mot = (bloc.getAttribute('data-tw-reste') || 'il reste [x] a repartir');
          etat.classList.add('tw-mix__etat--reste');
        } else {
          mot = (bloc.getAttribute('data-tw-trop') || '[x] de trop');
          etat.classList.add('tw-mix__etat--trop');
        }
        // « il reste 1 lightsticks » se lit faux. Un mot ecrit « singulier|pluriel »
        // s'accorde sur le nombre que la phrase vient d'annoncer ; un mot sans
        // barre traverse sans rien changer.
        var nb = reste === 0 ? somme : Math.abs(reste);
        mot = mot.replace(/([^\s|]+)\|([^\s|]+)/g, function (_, sing, plur) {
          return nb > 1 ? plur : sing;
        });
        etat.textContent = mot.replace('[n]', somme).replace('[m]', cible).replace('[x]', Math.abs(reste));
      };
      // Les pas de la maquette. Ils passent par la MEME valeur que la saisie au
      // clavier, et respectent le plafond de stock deja pose sur le champ : un
      // pas qui ignorerait le max ferait commander 20 jaunes quand il en reste 12.
      bloc.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-tw-mix-pas]') : null;
        if (!btn || btn.disabled) return;
        var champ = btn.parentElement.querySelector('[data-tw-mix-champ]');
        if (!champ || champ.disabled) return;
        var pas = parseInt(btn.getAttribute('data-tw-mix-pas'), 10) || 0;
        var val = parseInt(champ.value, 10);
        val = isFinite(val) ? val : 0;
        var haut = parseInt(champ.getAttribute('max'), 10);
        val += pas;
        if (val < 0) val = 0;
        if (isFinite(haut) && val > haut) val = haut;
        champ.value = val;
        poser();
      });

      bloc.addEventListener('input', poser);
      bloc.addEventListener('change', poser);
      poser();
    });
  }

  /*
    Bascule EU / UK / JP des pointures.

    La valeur du bouton radio n'est JAMAIS touchee : c'est la pointure EU, celle
    que Shopify connait. On ne reecrit que ce qui est lu, et chaque bouton garde
    « EU xx » en sous-titre. Une bascule qui changerait la valeur ferait commander
    une autre pointure que celle affichee.
  */
  function bascPointures(racine) {
    var groupes = racine.querySelectorAll('[data-tw-sys]');
    Array.prototype.forEach.call(groupes, function (grp) {
      var selecteur = grp.closest('.option-selector') || grp.parentElement;
      if (!selecteur) return;
      var etiquettes = selecteur.querySelectorAll('.opt-label--tw-sys');
      if (!etiquettes.length) return;

      var poser = function (idx) {
        Array.prototype.forEach.call(etiquettes, function (l) {
          var eu = l.getAttribute('data-tw-eu') || '';
          var alt = l.getAttribute(idx === 1 ? 'data-tw-alt1' : 'data-tw-alt2') || '';
          var principal = l.querySelector('.opt-label__text');
          var sous = l.querySelector('[data-tw-sys-sub]');
          if (!principal || !sous) return;
          if (idx === 0 || !alt) {
            principal.textContent = eu;
            sous.textContent = '';
          } else {
            principal.textContent = alt;
            sous.textContent = 'EU ' + eu;
          }
        });
        Array.prototype.forEach.call(grp.querySelectorAll('[data-tw-sys-btn]'), function (b) {
          b.classList.toggle('tw-sys__btn--on', parseInt(b.getAttribute('data-tw-sys-btn'), 10) === idx);
        });
      };

      Array.prototype.forEach.call(grp.querySelectorAll('[data-tw-sys-btn]'), function (b) {
        b.addEventListener('click', function () {
          poser(parseInt(b.getAttribute('data-tw-sys-btn'), 10));
        });
      });
      poser(0);
    });
  }

  /*
    Simulation de gravure. La saisie s'inscrit sur la tige en direct, avec le
    style choisi et le picto choisi.

    Deux pieges tenus ici :

    1. Le module vit dans un pli FERME au chargement. Tout ce qu'on y mesure
       rend zero, sans erreur, et un calage fait sur ce zero est faux. On ne
       cale donc qu'a l'ouverture du pli, et on recale a chaque ouverture.

    2. Le texte peut etre plus long que la tige. Plutot que le laisser deborder
       ou le couper, on reduit sa taille jusqu'a ce qu'il tienne. La reduction
       est bornee : sous 13 px la gravure ne se lit plus, on laisse alors la
       coupe faire son travail.
  */
  function apercuGravure(racine) {
    var modules = racine.querySelectorAll('.tw-eng:not(.tw-eng--housse)');
    Array.prototype.forEach.call(modules, function (mod) {
      var champ = mod.querySelector('.tw-eng__input');
      var sortie = mod.querySelector('[data-tw-eng-out]');
      if (!champ || !sortie) return;

      var attente = sortie.getAttribute('data-tw-vide') || '';
      var tailleMax = 26;

      function rendu() {
        var choisi = mod.querySelector('input[data-tw-rend]:checked');
        return choisi ? (choisi.getAttribute('data-tw-rend') || '') : '';
      }

      function picto() {
        var choisi = mod.querySelector('input[data-tw-picto]:checked');
        return choisi ? (choisi.getAttribute('data-tw-picto') || '') : '';
      }

      function caler() {
        var tige = sortie.parentElement;
        if (!tige) return;
        var large = tige.clientWidth - 84;
        // Pli ferme : la mesure ne veut rien dire, on ne cale pas dessus.
        if (large <= 0) return;
        sortie.style.fontSize = tailleMax + 'px';
        var taille = tailleMax;
        var garde = 0;
        while (sortie.scrollWidth > large && taille > 13 && garde < 40) {
          taille -= 1;
          sortie.style.fontSize = taille + 'px';
          garde += 1;
        }
      }

      function poser() {
        var texte = champ.value.replace(/\s+/g, ' ').trim();
        var signe = picto();
        var vide = texte === '';

        sortie.textContent = vide ? attente : (signe ? texte + ' ' + signe : texte);
        sortie.classList.toggle('tw-eng__grav--vide', vide);

        var quel = rendu();
        sortie.classList.remove('tw-eng__grav--script', 'tw-eng__grav--caps');
        if (quel) sortie.classList.add('tw-eng__grav--' + quel);

        // Sur du tissu, la pastille choisie est un FIL : c'est elle qui donne sa
        // couleur a la broderie. Sur du metal, il n'y a pas de pastille, et la
        // gravure garde la teinte creusee de la feuille de style.
        var pastille = mod.querySelector('input[data-tw-hex]:checked');
        sortie.style.color = pastille ? pastille.getAttribute('data-tw-hex') : '';

        caler();
      }

      champ.addEventListener('input', poser);
      Array.prototype.forEach.call(
        mod.querySelectorAll('input[data-tw-rend], input[data-tw-picto], input[data-tw-hex]'),
        function (radio) { radio.addEventListener('change', poser); }
      );

      // A l'ouverture du pli, la tige a enfin une largeur : c'est la qu'on cale.
      if (mod.tagName === 'DETAILS') {
        mod.addEventListener('toggle', function () { if (mod.open) poser(); });
      }
      window.addEventListener('resize', caler);

      poser();
    });
  }

  /*
    Fenetre video des pastilles.

    Le lien reste un VRAI lien vers le fichier : sans ce script, la video est
    encore atteignable, elle s'ouvre simplement dans l'onglet. On n'empeche donc
    jamais l'acces, on le rend seulement plus confortable.

    La fenetre est construite une seule fois et reutilisee. La source est posee a
    l'ouverture et RETIREE a la fermeture : une video laissee en place continue de
    se telecharger, et sur mobile elle mange le forfait de l'acheteuse.
  */
  function fenetreVideo(racine) {
    var liens = racine.querySelectorAll('[data-tw-video]');
    if (!liens.length) return;

    var boite = null, video = null, titre = null;

    function construire() {
      boite = document.createElement('div');
      boite.className = 'tw-vmodal';
      boite.setAttribute('hidden', '');
      boite.innerHTML =
        '<div class="tw-vmodal__voile" data-tw-fermer></div>' +
        '<div class="tw-vmodal__boite" role="dialog" aria-modal="true">' +
          '<p class="tw-vmodal__titre"></p>' +
          '<button type="button" class="tw-vmodal__fermer" data-tw-fermer aria-label="Fermer">&times;</button>' +
          '<video class="tw-vmodal__video" controls playsinline preload="none"></video>' +
        '</div>';
      document.body.appendChild(boite);
      video = boite.querySelector('video');
      titre = boite.querySelector('.tw-vmodal__titre');
      boite.addEventListener('click', function (e) {
        if (e.target.hasAttribute && e.target.hasAttribute('data-tw-fermer')) fermer();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !boite.hasAttribute('hidden')) fermer();
      });
    }

    function fermer() {
      if (!boite) return;
      video.pause();
      // On RETIRE la source : sinon le telechargement continue en fond.
      video.removeAttribute('src');
      video.removeAttribute('poster');
      video.load();
      boite.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
    }

    Array.prototype.forEach.call(liens, function (lien) {
      lien.addEventListener('click', function (e) {
        e.preventDefault();
        if (!boite) construire();
        var poster = lien.getAttribute('data-tw-poster');
        titre.textContent = lien.getAttribute('data-tw-titre') || '';
        if (poster) video.setAttribute('poster', poster);
        video.setAttribute('src', lien.getAttribute('data-tw-video'));
        boite.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
        var joue = video.play();
        if (joue && joue.catch) joue.catch(function () {});
      });
    });
  }

  /*
    LA VIDEO JOUE DANS LA GALERIE, PAS DANS UNE FENETRE.

    Demande du 02/09/2026. La vignette video est une vignette comme les autres :
    la cliquer doit remplacer la photo, a la place et a la taille de la photo,
    comme le ferait n'importe quelle autre vignette. Une fenetre par-dessus la
    page sortait l'acheteuse de la fiche pour montrer trente secondes d'atelier.

    fenetreVideo() n'est donc plus appelee. Elle reste dans le fichier, et sa
    feuille avec : si la modale devait revenir un jour, tout est la.
  */
  function videoDansGalerie(racine) {
    var section = racine.querySelector('.tw-refonte');
    if (!section) return;
    var liens = section.querySelectorAll('[data-tw-video]');
    if (!liens.length) return;
    var cadre = section.querySelector('.main-image');
    if (!cadre) return;

    var boite = cadre.querySelector('.tw-gvideo');
    if (!boite) {
      boite = document.createElement('div');
      boite.className = 'tw-gvideo';
      boite.hidden = true;
      boite.innerHTML = '<video class="tw-gvideo__video" controls playsinline preload="none"></video>';
      cadre.appendChild(boite);
    }
    var video = boite.querySelector('video');

    var fermer = function () {
      if (boite.hidden) return;
      video.pause();
      // On RETIRE la source : sinon le telechargement continue en fond.
      video.removeAttribute('src');
      video.load();
      boite.hidden = true;
    };

    Array.prototype.forEach.call(liens, function (lien) {
      lien.addEventListener('click', function (e) {
        e.preventDefault();
        // Le theme ecoute les clics sur .thumbnail pour changer la grande photo.
        // Cette vignette-ci n'en est pas une : on lui coupe la parole.
        e.stopPropagation();
        var poster = lien.getAttribute('data-tw-poster');
        if (poster) { video.setAttribute('poster', poster); } else { video.removeAttribute('poster'); }
        video.setAttribute('src', lien.getAttribute('data-tw-video'));
        boite.hidden = false;
        var joue = video.play();
        if (joue && joue.catch) joue.catch(function () {});
        Array.prototype.forEach.call(section.querySelectorAll('.thumbnail'), function (t) {
          t.classList.remove('selected');
        });
        lien.classList.add('selected');
      });
    });

    // Toute autre vignette rend la parole a la photo.
    Array.prototype.forEach.call(section.querySelectorAll('.thumbnail'), function (t) {
      if (t.hasAttribute('data-tw-video')) return;
      t.addEventListener('click', fermer);
    });
  }

  /*
    Les fleches de la bande de photos clientes. Le defilement lui-meme est natif
    (scroll-snap) : ce code n'ajoute qu'un confort pour les souris a molette
    unique, et son absence ne retire rien.
  */
  function carrouselUgc(racine) {
    var bandes = racine.querySelectorAll('[data-tw-ugc-bande]');
    Array.prototype.forEach.call(bandes, function (bande) {
      var tete = bande.parentElement.querySelector('[data-tw-ugc-fleches]');
      if (!tete) return;
      var prec = tete.querySelector('[data-tw-ugc-prec]');
      var suiv = tete.querySelector('[data-tw-ugc-suiv]');

      var pas = function () {
        var vue = bande.querySelector('.tw-ugc__vue');
        // Une vue plus la gouttiere : on avance d'une photo entiere, jamais
        // d'une fraction qui laisserait une image coupee en bord de bande.
        return vue ? vue.getBoundingClientRect().width + 14 : bande.clientWidth;
      };

      var etat = function () {
        var max = bande.scrollWidth - bande.clientWidth - 2;
        if (prec) prec.disabled = bande.scrollLeft <= 2;
        if (suiv) suiv.disabled = bande.scrollLeft >= max;
      };

      if (prec) prec.addEventListener('click', function () { bande.scrollLeft -= pas(); });
      if (suiv) suiv.addEventListener('click', function () { bande.scrollLeft += pas(); });
      bande.addEventListener('scroll', etat);
      window.addEventListener('resize', etat);
      etat();
    });
  }

  /*
    La video du comparateur « Comment choisir son baton » se lance TOUTE SEULE
    a l'ouverture du menu deroulant, et se coupe a la fermeture. Demande du
    03/09/2026.

    « muted » est obligatoire : aucun navigateur n'autorise une lecture
    automatique avec le son, seule une lecture automatique MUETTE passe. Le
    bouton haut-parleur des controles natifs reste la pour qui veut le son.

    « preload=none » n'empeche rien : appeler .play() charge la video a la
    volee. Il y a juste un instant avant que l'image ne bouge, le temps du
    premier octet.
  */
  function videoComparateurAuto(racine) {
    var boites = racine.querySelectorAll('.tw-cmpr');
    Array.prototype.forEach.call(boites, function (boite) {
      var video = boite.querySelector('.tw-ig-embed__video');
      if (!video) return;
      boite.addEventListener('toggle', function () {
        if (boite.open) {
          var joue = video.play();
          if (joue && joue.catch) joue.catch(function () {});
        } else {
          video.pause();
        }
      });
    });
  }

  // Le second ajout attend la confirmation du premier pour conserver les deux lignes.
  function ajoutCompagnon(racine) {
    var formulaires = racine.querySelectorAll('form.product-purchase-form');
    Array.prototype.forEach.call(formulaires, function (form) {
      var section = form.closest('[data-section-type="main-product"]');
      if (!section || !section.querySelector('[data-tw-add-companion]')) return;
      if (form.getAttribute('data-tw-add-companion-bound') === 'true') return;
      form.setAttribute('data-tw-add-companion-bound', 'true');
      var variantEnAttente = null;
      form.addEventListener('submit', function () {
        var conteneur = form.closest('[data-section-type="main-product"]') || document;
        var caseACocher = conteneur.querySelector('[data-tw-add-companion]');
        variantEnAttente = (caseACocher && caseACocher.checked) ? caseACocher.getAttribute('data-variant-id') : null;
      });
      document.documentElement.addEventListener('theme:cartchanged', function () {
        if (!variantEnAttente) return;
        var variantId = variantEnAttente;
        variantEnAttente = null;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function (reponse) {
          if (reponse.ok) {
            document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
            );
          }
        }).catch(function () {});
      });
    });
  }

  function demarrer(racine) {
    marquerLaPage(racine);
    carrouselUgc(racine);
    videoComparateurAuto(racine);
    videoDansGalerie(racine);
    bascPointures(racine);
    repartition(racine);
    totalSurLeBouton(racine);
    nuancier(racine);
    fermerGravure(racine);
    recapConfigurateur(racine);
    compteurGravure(racine);
    apercuGravure(racine);
    tarifsParOffre(racine);
    gravureVersApp(racine);
    barreCollante(racine);
    ajoutCompagnon(racine);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  } else {
    demarrer(document);
  }

  // Le theme rejoue ses sections dans l'editeur : sans ca, le compteur et la
  // barre disparaissent des qu'on modifie un reglage.
  document.addEventListener('shopify:section:load', function (e) {
    demarrer(e.target);
  });
})();
